import AttendanceService from "../../services/AttendanceService";
import {
  MARK_ATTENDANCE_REQUEST,
  MARK_ATTENDANCE_SUCCESS,
  MARK_ATTENDANCE_FAILURE,
  RESET_ATTENDANCE_STATE,
  SET_LOCATION_ERROR,
  CLEAR_LOCATION_ERROR,
  FETCH_ATTENDANCE_HISTORY_REQUEST ,
  FETCH_ATTENDANCE_HISTORY_SUCCESS ,
  FETCH_ATTENDANCE_HISTORY_FAILURE 
} from "./actionTypes";

const markAttendanceRequest = () => ({ type: MARK_ATTENDANCE_REQUEST });
const markAttendanceSuccess = (attendType) => ({
  type: MARK_ATTENDANCE_SUCCESS,
  payload: attendType,
});
const markAttendanceFailure = (error) => ({
  type: MARK_ATTENDANCE_FAILURE,
  payload: error,
});

export const setLocationError = (error) => ({
  type: SET_LOCATION_ERROR,
  payload: error,
});

export const clearLocationError = () => ({
  type: CLEAR_LOCATION_ERROR,
});

export const resetAttendanceState = () => ({ type: RESET_ATTENDANCE_STATE });

export const markAttendance =
  ({ attendType, lid, bid, overNight }) =>
  async (dispatch) => {
    dispatch(markAttendanceRequest());
    dispatch(clearLocationError());

    try {
      // Get location with better error handling
      let position;
      try {
        position = await AttendanceService.getCurrentPosition();
      } catch (locationErr) {
        // Dispatch location error specifically
        dispatch(setLocationError(locationErr.message));
        dispatch(markAttendanceFailure(locationErr.message));
        return false;
      }

      const result = await AttendanceService.postAttendance({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        lid,
        bid,
        attendType,
        overNight,
      });

      if (!result.responceType) {
        throw new Error(result.responceMessage || "Could not record attendance.");
      }

      dispatch(markAttendanceSuccess(attendType));
      return true;
    } catch (err) {
      const message = err?.message || "Could not record attendance.";
      dispatch(markAttendanceFailure(message));
      return false;
    }
  };

const fetchHistoryRequest = () => ({ type: FETCH_ATTENDANCE_HISTORY_REQUEST });
const fetchHistorySuccess = (history) => ({
  type: FETCH_ATTENDANCE_HISTORY_SUCCESS,
  payload: history,
});
const fetchHistoryFailure = (error) => ({
  type: FETCH_ATTENDANCE_HISTORY_FAILURE,
  payload: error,
});

export const fetchAttendanceHistory = () => async (dispatch) => {
  dispatch(fetchHistoryRequest());
  
  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("Username not found");
    }
    
    const result = await AttendanceService.getAttendanceHistory(username);
    
    if (!result.responceType) {
      throw new Error(result.responceMessage || "Could not fetch attendance history");
    }

    const formatDistance = (rawDistance) => {
      if (rawDistance === null || rawDistance === undefined || rawDistance === '') return 'N/A';
      const meters = parseFloat(rawDistance);
      if (isNaN(meters)) return 'N/A';
      if (meters < 1000) return `${Math.round(meters)} m`;
      return `${(meters / 1000).toFixed(2)} km`;
    };
    
    const formatStatus = (attendStatus) => {
      if (attendStatus === null || attendStatus === undefined || attendStatus === '') return '⏳ Pending';
      return attendStatus === 'Y' ? '✅ Valid' : '❌ Invalid';
    };

    const history = result.responceMessage.slice(0, 10).map(record => ({
      time: record.Time,
      inout: record.INOUT === 'in' ? 'Check In' : 'Check Out',
      overNights: record.OverNights === 'Y' ? 'Yes' : 'No',
      distance: formatDistance(record.Distance),
      status: formatStatus(record.AttendStatus)
    }));
    
    dispatch(fetchHistorySuccess(history));
  } catch (err) {
    dispatch(fetchHistoryFailure(err.message));
  }
};